"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmwareErrorCode = void 0;
/**
 * A list of error codes for error conditions on the device
 */
var FirmwareErrorCode;
(function (FirmwareErrorCode) {
    FirmwareErrorCode[FirmwareErrorCode["Other"] = 0] = "Other";
    FirmwareErrorCode[FirmwareErrorCode["Disconnected"] = 1] = "Disconnected";
    FirmwareErrorCode[FirmwareErrorCode["Occluded"] = 2] = "Occluded";
    FirmwareErrorCode[FirmwareErrorCode["ImuError"] = 3] = "ImuError";
})(FirmwareErrorCode = exports.FirmwareErrorCode || (exports.FirmwareErrorCode = {}));
